import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './RestaurantSidebar.css'; // ✅ نستخدم نفس التنسيق
import { useLanguage } from '../contexts/LanguageContext';
// استيراد أيقونات MUI
import HomeIcon from '@mui/icons-material/Home';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatIcon from '@mui/icons-material/Chat';
import StorageIcon from '@mui/icons-material/Storage';
import BuildIcon from '@mui/icons-material/Build';
import LogoutIcon from '@mui/icons-material/Logout';

const iconStyles = {
  home: { color: '#1976d2' }, // blue
  restaurant: { color: '#43a047' }, // green
  driver: { color: '#fbc02d' }, // yellow
  location: { color: '#e53935' }, // red
  report: { color: '#8e24aa' }, // purple
  orders: { color: '#00838f' }, // teal
  notifications: { color: '#ff9800' }, // orange
  settings: { color: '#616161' }, // grey
  chat: { color: '#0288d1' }, // light blue
  database: { color: '#6d4c41' }, // brown
  tools: { color: '#c62828' }, // dark red
  logout: { color: '#d32f2f' }, // logout red
};

const AdminSidebar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const { t, language } = useLanguage();

  return (
    <div className={`restaurant-sidebar admin-sidebar ${language === 'ar' ? 'sidebar-rtl' : 'sidebar-ltr'}`}>
      <div className="restaurant-sidebar-header">
        <h2>AT Delivery</h2>
        <p>لوحة الأدمن</p>
      </div>

      <div className="restaurant-sidebar-menu">
        <Link to="/dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`}>
          <span className="menu-icon"><HomeIcon style={iconStyles.home} /></span>
          <span className="menu-text">{t('home')}</span>
        </Link>

        <Link to="/admin/restaurant-management" className={`menu-item ${isActive('/admin/restaurant-management') ? 'active' : ''}`}>
          <span className="menu-icon"><StoreMallDirectoryIcon style={iconStyles.restaurant} /></span>
          <span className="menu-text">{t('admin_restaurant_management')}</span>
        </Link>

        <Link to="/admin/driver-management" className={`menu-item ${isActive('/admin/driver-management') ? 'active' : ''}`}>
          <span className="menu-icon"><DirectionsCarIcon style={iconStyles.driver} /></span>
          <span className="menu-text">{t('admin_driver_management')}</span>
        </Link>

        <Link to="/admin/driver-tracking" className={`menu-item ${isActive('/admin/driver-tracking') ? 'active' : ''}`}>
          <span className="menu-icon"><LocationOnIcon style={iconStyles.location} /></span>
          <span className="menu-text">{t('admin_driver_tracking')}</span>
        </Link>
        
        <Link to="/admin/driver-tracking-reports" className={`menu-item ${isActive('/admin/driver-tracking-reports') ? 'active' : ''}`}>
          <span className="menu-icon"><AssessmentIcon style={iconStyles.report} /></span>
          <span className="menu-text">{t('admin_driver_tracking_reports')}</span>
        </Link>
        
        <Link to="/admin/orders" className={`menu-item ${isActive('/admin/orders') ? 'active' : ''}`}>
          <span className="menu-icon"><Inventory2Icon style={iconStyles.orders} /></span>
          <span className="menu-text">{t('orders')}</span>
        </Link>

        <Link to="/admin/reports" className={`menu-item ${isActive('/admin/reports') ? 'active' : ''}`}>
          <span className="menu-icon"><AssessmentIcon style={iconStyles.report} /></span>
          <span className="menu-text">{t('reports')}</span>
        </Link>

        <Link to="/notifications" className={`menu-item ${isActive('/notifications') ? 'active' : ''}`}>
          <span className="menu-icon"><NotificationsIcon style={iconStyles.notifications} /></span>
          <span className="menu-text">{t('notifications')}</span>
        </Link>

        <Link to="/admin/settings" className={`menu-item ${isActive('/admin/settings') ? 'active' : ''}`}>
          <span className="menu-icon"><SettingsIcon style={iconStyles.settings} /></span>
          <span className="menu-text">{t('settings')}</span>
        </Link>
        <Link to="/admin/chat" className={`menu-item ${isActive('/admin/chat') ? 'active' : ''}`}>
          <span className="menu-icon"><ChatIcon style={iconStyles.chat} /></span>
          <span className="menu-text">{t('admin_chat')}</span>
        </Link>
        
        <Link to="/admin/database" className={`menu-item ${isActive('/admin/database') ? 'active' : ''}`}>
          <span className="menu-icon"><StorageIcon style={iconStyles.database} /></span>
          <span className="menu-text">{t('admin_database')}</span>
        </Link>

        <Link to="/admin/tools" className={`menu-item ${isActive('/admin/tools') ? 'active' : ''}`}>
          <span className="menu-icon"><BuildIcon style={iconStyles.tools} /></span>
          <span className="menu-text">{t('admin_tools')}</span>
        </Link>
      </div>

      <div className="restaurant-sidebar-footer">
        <button className="logout-button" onClick={() => {
          localStorage.clear();
          window.location.href = '/login';
        }}>
          <span className="logout-icon"><LogoutIcon style={iconStyles.logout} /></span>
          {t('logout')}
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
